import { Icon } from "@-/dev.improve.haniverse.components.ui.icon";
import { Pressable } from "@-/com.npmjs.react-native";

export function DecompositionTreeButton({ onPress }: { onPress: () => void }) {
  return (
    <Pressable
      accessibilityLabel="Open decomposition tree"
      accessibilityRole="button"
      className="size-8 items-center justify-center rounded-xs active:bg-accent"
      hitSlop={6}
      onPress={onPress}
    >
      <Icon className="text-muted-foreground" name="ImTree" size={18} />
    </Pressable>
  );
}
